import React from "react";
import MantineAvathar from "../../../components/mantine/avathar";
import MantineText from "../../../components/mantine/text";
import MantineGroup from "../../../components/mantine/group";

const AvatarComponent = (props:any) => {

  const { item, currentPrimaryColor, showName, src } = props;
  return (
  <MantineGroup gap="sm" className="responsive-group-mobile">
    <MantineAvathar size={40} color={currentPrimaryColor} radius={40} src={src}>
      {item?.name?.charAt(0).toUpperCase()}
      {/* {item?.lastName?.charAt(0).toUpperCase()} */}
    </MantineAvathar>
    {!showName && <div>
      <MantineText fw={500} name={`${item?.name} ${item?.name}`} />
      {/* <MantineText fz="xs" c="dimmed" name={`${item?.email}`} /> */}
    </div>}
  </MantineGroup>
   );
};
export default AvatarComponent;
